module.exports = __webpack_public_path__ + "static/media/super_user_settings.dfd317ed.svg";